/*
 * /journal (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import {
	Container,
	Divider,
	Page,
	PageHeader,
	Skeleton,
} from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { v4 as uuidv4 } from "uuid"
import { JournalEntriesList } from "../../features/journal/components/journal-entries-list"
import { JournalReminderSettings } from "../../features/journal/components/journal-reminder-settings"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/journal/")({
	component: JournalsPage,
	loader: authPageLoader,
})

function JournalsPage() {
	const { user } = Route.useLoaderData()

	const { data: journalEntries, isLoading } =
		trpc.journalEntry.getAllByFilter.useQuery({
			sort: { column: "createdAt", direction: "desc" },
			where: { ownerId: user.id },
		})

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Psychology Journals"}
					left={{
						href: "/dashboard",
						label: "Dashboard",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				{!isLoading && journalEntries && (
					<p className={"text-muted-foreground text-sm"}>
						{`${journalEntries.length} ${journalEntries.length === 1 ? "entry" : "entries"}`}
					</p>
				)}
				<div className={"space-y-6"}>
					<JournalReminderSettings />
					{isLoading ? (
						<div className={"space-y-4"}>
							{[1, 2, 3].map((i) => (
								<Skeleton key={i} className={"h-[140px] w-full rounded-lg"} />
							))}
						</div>
					) : (
						<JournalEntriesList
							journalEntries={journalEntries || []}
							newId={uuidv4()}
						/>
					)}
				</div>
			</Container>
		</Page>
	)
}
